import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, BellRinging } from "@phosphor-icons/react";
import { useFollows, normId, pairKey } from "../context/FollowsContext";
import { useAuth } from "../context/AuthContext";

// Cloche de suivi réutilisable multi-sports (foot / tennis / basket).
// <span role="button"> pour éviter un bouton imbriqué dans une carte cliquable.
export const FollowBell = ({ match, sport = "foot", size = 18, className = "" }) => {
  const { user } = useAuth();
  const { isFollowed, toggle } = useFollows();
  const navigate = useNavigate();
  const id = sport === "foot" ? normId(match?.match_id ?? match?.fixture_id) : pairKey(match);
  const on = isFollowed(sport, match);

  const handle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) { navigate("/login"); return; }
    toggle(sport, match);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      data-testid={`follow-bell-${id}`}
      aria-pressed={on}
      aria-label={on ? "Ne plus suivre ce match" : "Suivre ce match"}
      title={on ? "Suivi" : "Suivre"}
      onClick={handle}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handle(e); }}
      className={`inline-flex items-center justify-center rounded-full transition-colors cursor-pointer shrink-0 ${
        on ? "text-perf-excellent" : "text-white/45 hover:text-white/80"
      } ${className}`}
      style={{
        width: size + 14, height: size + 14,
        background: on ? "rgba(0,230,118,0.14)" : "rgba(255,255,255,0.06)",
        border: on ? "1px solid rgba(0,230,118,0.45)" : "1px solid rgba(255,255,255,0.1)",
      }}
    >
      {on ? <BellRinging size={size} weight="fill" /> : <Bell size={size} weight="regular" />}
    </span>
  );
};
